import useFormSubmit from "@/hooks/useFormSubmit";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daihu4joh653ivfvodo0";

export default function SubscribeSection() {
  const { status, message, submit } = useFormSubmit(
    SUBMIT_ADDR,
    "订阅成功！新剧与榜单更新会第一时间发到你的邮箱。"
  );

  return (
    <section className="py-16 md:py-20" aria-labelledby="subscribe-title">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg border border-background-200/70">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dark%20background%20of%20swirling%20crimson%20silk%20fabric%20with%20golden%20light%20streaks%2C%20luxurious%20texture%2C%20dramatic%20moody%20lighting%2C%20rich%20shadows%2C%20elegant%20composition%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=1600&height=700&seq=hl-cta-silk&orientation=landscape"
            alt="深红绸缎与金色光影的抽象背景"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/90 to-background-50/60"></div>

          <div className="relative grid grid-cols-1 gap-8 p-6 md:p-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
            <div>
              <span className="text-xs font-label tracking-[0.3em] text-accent-400">更新订阅</span>
              <h2 id="subscribe-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                每周一封，把同款好剧送到你邮箱
              </h2>
              <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
                订阅后我们会发送榜单变动、上新速递与同款推荐合集。只发有价值的内容，随时可以退订。
              </p>
              <ul className="mt-5 flex flex-wrap gap-x-6 gap-y-3 text-xs font-label text-foreground-600">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-primary-400" aria-hidden="true"></i>
                  榜单变动提醒
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-primary-400" aria-hidden="true"></i>
                  新剧速递
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-primary-400" aria-hidden="true"></i>
                  同款推荐合集
                </li>
              </ul>
            </div>

            <form
              onSubmit={submit}
              data-readdy-form
              id="subscribe-form"
              className="rounded-lg border border-background-200/70 bg-background-100/80 p-5 backdrop-blur md:p-6"
              noValidate
            >
              <label htmlFor="subscribe-email" className="block text-xs font-label text-foreground-600">
                邮箱地址
              </label>
              <input
                id="subscribe-email"
                name="email"
                type="email"
                required
                autoComplete="email"
                placeholder="you@example.com"
                className="mt-2 w-full rounded-md border border-background-300/70 bg-background-50 px-3.5 py-3 text-sm font-label text-foreground-950 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none"
              />

              <input
                className="contact-field-verify"
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />

              <label htmlFor="subscribe-interest" className="mt-4 block text-xs font-label text-foreground-600">
                最想要的口味（可选）
              </label>
              <select
                id="subscribe-interest"
                name="interest"
                defaultValue=""
                className="mt-2 w-full rounded-md border border-background-300/70 bg-background-50 px-3.5 py-3 text-sm font-label text-foreground-950 focus:border-primary-400 focus:outline-none"
              >
                <option value="">不限，全都想看看</option>
                <option value="豪门恩怨">豪门恩怨</option>
                <option value="重生逆袭">重生逆袭</option>
                <option value="都市情感">都市情感</option>
                <option value="悬疑复仇">悬疑复仇</option>
                <option value="职场博弈">职场博弈</option>
                <option value="甜宠日常">甜宠日常</option>
              </select>

              <button
                type="submit"
                disabled={status === "loading"}
                className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-label font-medium text-background-950 transition-colors hover:bg-primary-400 disabled:opacity-60 cursor-pointer"
              >
                <i className="ri-send-plane-line" aria-hidden="true"></i>
                {status === "loading" ? "提交中…" : "立即订阅"}
              </button>

              {message && (
                <p
                  role="status"
                  className={`mt-3 text-xs leading-relaxed ${
                    status === "success" ? "text-accent-400" : "text-primary-400"
                  }`}
                >
                  {message}
                </p>
              )}
              <p className="mt-3 text-[11px] leading-relaxed text-foreground-500">
                提交即表示你同意我们通过邮件发送更新内容，我们不会向第三方共享你的邮箱。
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}